import { fetch } from '@atlassian/eoc-fetch';

import type { GetIsCurrentSiteSyncEnabledResponse } from './types';

export const getIsCurrentSiteSyncEnabled = (): Promise<boolean> =>
	fetch<GetIsCurrentSiteSyncEnabledResponse>(`/v1/entity-sync/is-current-site-enabled`).then(
		(response) => response.data.enabled,
	);
